import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { DangerouslyHtml } from 'apps/auth/components/common/DangerouslyHtml/DangerouslyHtml';
import { Stories } from 'apps/auth/components/common/Layout/Stories/Stories';
import StoryLayout from 'apps/auth/components/common/Layout/Stories/StoryLayout';
import { PROMO_SCREEN_SHOWN, SHARE_LINK_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { SCREEN } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { METHOD_INVITATION } from 'apps/auth/constants/amplitude/AmplitudeParamValues';
import { getLocalizedRawAmount } from 'apps/auth/helpers/formats';
import { resolveArguments } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import usePreloadStoryImages from 'apps/auth/hooks/usePreloadStoryImages';

const MgmPromoStories = (props) => {
    const { country } = useApp();
    const { lang } = useLanguage();
    const { notNowButton, shareLinkButton } = usePageMessages();
    const { bonusReferralInfo } = useExtra();
    const slides = props.sliders?.slides;
    const duration = props.sliders?.duration * 1000;
    const imagesLoaded = usePreloadStoryImages(slides);
    const hasTopButton = props.sliders?.not_now;

    const getAmountPerUser = (amount = '') => {
        return getLocalizedRawAmount(lang, country, amount, 2, true);
    };

    useEffect(() => {
        amplitude.getInstance().logEvent(PROMO_SCREEN_SHOWN, { [SCREEN]: METHOD_INVITATION });
    }, []);

    const getMaxPossibleAmount = (bonusReferralInfo = {}) => {
        let amount = Number(bonusReferralInfo?.referralInfo?.bonus?.value) * Number(bonusReferralInfo?.referralInfo?.bonus?.count);
        return getLocalizedRawAmount(lang, country, amount, 2, true);
    };

    const getSteps = () => {
        let steps = [];
        if (slides) {
            steps = slides.map((slide) => {
                return (
                    <StoryLayout
                        key={slide.order}
                        contentPosition={slide.position}
                        topButtonCaption={hasTopButton ? notNowButton : null}
                        onTopButtonClick={props.onTopButtonClick}
                        title={<DangerouslyHtml dangerouslyHtml={slide.title} />}
                        largeTitle
                        subtitle={
                            <DangerouslyHtml
                                dangerouslyHtml={resolveArguments(slide.subtitle, [
                                    getAmountPerUser(bonusReferralInfo?.referralInfo?.bonus?.value) + ' ' + bonusReferralInfo?.referralInfo?.bonus?.ccyIso,
                                    getMaxPossibleAmount(bonusReferralInfo) + ' ' + bonusReferralInfo?.referralInfo?.bonus?.ccyIso,
                                ])}
                            />
                        }
                        imgA={slide.web_a_bg_img_url}
                        imgA2x={slide.web_a2x_bg_img_url}
                        imgB={slide.web_b_bg_img_url}
                        imgB2x={slide.web_b2x_bg_img_url}
                        fullwidthImg={slide.fullwidthImg}
                        bottomButtonCaption={shareLinkButton}
                        onBottomButtonClick={() => {
                            amplitude.getInstance().logEvent(SHARE_LINK_CLICKED);
                            props.onBottomButtonClick();
                        }}
                        variant="secondary_base"
                        linkInfo={slide.link_info}
                    />
                );
            });
        }
        return steps;
    };

    return <>{imagesLoaded && <Stories steps={getSteps()} isInverted infinityLoop duration={duration} />}</>;
};

MgmPromoStories.propTypes = {
    closeModal: PropTypes.func,
};
export default MgmPromoStories;
